import * as Yup from 'yup'
import { imageNullInputSchema } from './common'

const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  categoryId: Yup.number().required('Category is required'),
  subCategoryId: Yup.number().required('Sub category is required'),
  images: Yup.array().of(imageNullInputSchema),
  description: Yup.string().required('Description is required'),
  infos: Yup.object({
    availability: Yup.string().required('Availability is required'),
    pricePerVisit: Yup.number().required('Price Per visit is required'),
    additionalNote: Yup.string().notRequired(),
    includes: Yup.array()
      .of(Yup.string().required('Inscludes is required'))
      .required('Includes is required'),
  }),
})

export default { validationSchema }
